module.exports = __webpack_public_path__ + "static/img/app-img.ec88e107.png";